<template lang="html">
  <div class="footer" ref="footer">
    <div class="footer-top">
      <div class="main-content ul-box">
        <!-- 底部目录 -->
        <ul class="fl" v-for="(item,index) in footerAlls" :key="index">
          <p>{{item.name}}</p>

          <li v-if="index==footerAlls.length-1" class="a">
            <img class="li-code" :src="imgUrl+item.sysFooterSubs[0].content" alt />
          </li>
          <li v-else v-for="(ele,eleIndex) in item.sysFooterSubs" :key="eleIndex" class="c">
            <img v-if="index==0" class="li-icon" :src="imgUrl+ele.img" alt />
            <span @click="$router.push(ele.link)">{{ele.content}}</span>
            <!-- <router-link to="/login" tag='li'>{{ele.content}}</router-link> -->

          </li>
        </ul>
        <ul class='fl'>
          <p>小程序</p>
          <li>
            <img class="li-code" src="@/assets/images/mini.jpg" alt />
          </li>

        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="main-content">
        <p>
          {{sysFooterBottom.rightsReserved}}
          <span v-if="sysFooterBottom.record" class='cur-pointer'
            @click='toLink'>{{sysFooterBottom.record.split(' ')[1]}}
            <span class='color-theme'>{{sysFooterBottom.record.split(' ')[2]}}</span>
            {{sysFooterBottom.record.split(' ')[3]}}</span>
          <img :src="imgUrl+sysFooterBottom.img" alt />
          {{sysFooterBottom.statement}} {{sysFooterBottom.legal}}

        </p>
        <p>{{sysFooterBottom.content}}</p>
      </div>
    </div>
    <!-- <transition name="el-zoom-in-center"> -->
    <div v-if="!hideAds">
      <div ref="footerAds" class="footer-ads" v-show="isShow">
        <div v-if="!footerAds" class="ads-tip" @click="openAds">
          <img width="28" height="32" src="../assets/images/arrow_right1.png" alt />
        </div>
        <div class="ads-content">
          <div class="left fl">
            <div class="wenzi1">{{sysFooterEdgeQuery.oneText}}</div>
            <div class="wenzi2"><span>房屋装修监理管理平台</span></div>
            <div class="btn" @click="freeBooking">{{sysFooterEdgeQuery.twoImg}}</div>
          </div>
          <div class="tel fl">
            <div class="line">
              <img style="width: 16px; height: 20px;" src="../assets/images/index-phone02.png" alt="">
              <span>{{sysFooterEdgeQuery.mobilephone}}</span>
            </div>
            <div class="line">
              <img style="width: 20px;height: 20px;" src="../assets/images/index-phone01.png" alt="">
              <span>{{sysFooterEdgeQuery.telephone}}</span>
            </div>
          </div>
          <div class="pic fl">
            <img :src="sysFooterEdgeQuery.oneImg" alt="">
          </div>
          <div class="ads-close2 fl" @click="closeAds">
            <i class="el-icon-close"></i>
            关闭
          </div>
        </div>
      </div>
    </div>
    <!-- 免费预约 -->
    <freebooking-Box v-if="dialogVisible"></freebooking-Box>
  </div>
</template>

<script>
  import * as indexApi from "@/api/indexApi";
  import VDistpicker from "v-distpicker";
  import freeBookingBox from "./freeBookingBox.vue"; //免费预约弹框
  export default {
    props: {
      hideAds: Boolean,
    },
    components: {
      VDistpicker,
      "freebooking-Box": freeBookingBox,
    },
    data() {
      return {
        footerAds: true,
        footerAlls: [],
        sysFooterEdgeQuery: {},
        sysFooterBottom: {},
        imgUrl: process.env.IMG_URL, //全局
        screenWidth: "", //浏览器视口高度
        dialogVisible: false, //免费预约弹框
        isShow: false,
      };
    },
    computed: {
      optionSetting() {
        return {
          step: 0.4,
        };
      },
    },
    methods: {
      toLink() {
        window.open(this.sysFooterBottom.recordLink);
      },
      // 关闭底部广告
      closeAds: function() {
        this.screenWidth = document.body.clientWidth - 66; //最小是1220px
        this.footerAds = false;
        this.$refs.footerAds.style.left = -this.screenWidth + "px";
        this.$refs.footerAds.style.transition = " all 0.5s linear";
      },
      // 打开广告
      openAds: function() {
        this.footerAds = true;
        this.$refs.footerAds.style.left = 0;
        this.$refs.footerAds.style.transition = " all 0.5s linear";
      },
      // 免费预约弹框
      freeBooking() {
        this.dialogVisible = true;
      },

      //底部
      getFooterTitle() {
        indexApi.getFooterTitle().then((res) => {
          if (res.data.code == "200") {
            this.footerAlls = res.data.data.footerAlls;
            this.sysFooterEdgeQuery = res.data.data.sysFooterEdgeQuery;
            this.sysFooterBottom = res.data.data.sysFooterBottom;
          }
        });
      },
      handleScroll: function() {
        // 等footer在可视区域出现时，展示广告条
        if (!this.isElementNotInViewport(this.$refs.footer)) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
        //移除滚动监听事件 触发一次
        // window.removeEventListener("scroll", this.handleScroll);
      },
    },
    created: function() {
      this.getFooterTitle();
    },
    mounted() {
      window.onresize = () => {
        return (() => {
          if (!this.footerAds) {
            this.screenWidth = document.body.clientWidth - 66;
            this.$refs.footerAds.style.left = -this.screenWidth + "px";
            this.$refs.footerAds.style.transition = " all 0.5s linear";
          }
        })();
      };

      window.addEventListener("scroll", this.handleScroll);
    },
  };
</script>

<style lang="scss" scoped>
  .footer {
    width: 100%;
    height: 316px;
    position: relative;

    .footer-top {
      height: 250px;
      background: #333;
      color: #999;

      .ul-box {
        // display: flex;
        overflow: hidden;
      }

      ul {
        // flex: 1;
        width: 160px;

        p {
          color: #fff;
          font-size: 18px;
          padding: 30px 0 10px;
          box-sizing: border-box;
        }

        li {
          display: flex;
          align-items: center;
          font-size: 14px;
          margin-top: 8px;

          .li-icon {
            // 按照宽度缩放
            width: 20px;
            margin-right: 18px;
          }

          .li-code {
            width: 86px;
            height: 86px;
          }
        }

        li:hover {
          cursor: pointer;
        }
      }

      ul:first-child {
        width: 460px;

        // li同级元素也会被计算
        li:nth-child(3) {
          color: #d58f00;
          font-size: 20px;
        }
      }

      ul:last-child {
        width: 86px;
      }
    }

    .footer-bottom {
      height: 66px;
      line-height: 20px;
      padding: 14px 0;
      box-sizing: border-box;
      background: #25292e;
      text-align: center;
      font-size: 12px;
      color: #fff;

      p {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 16px;
          height: 18px;

          margin: 0 10px;
        }
      }
    }

    .footer-ads {
      width: 100%;
      height: 168px;
      background: #fff;
      // background: rgba(255,255,255,0.9);
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 3;
      font-weight: bold;

      .ads-tip {
        width: 66px;
        height: 168px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        background: #a20a0e;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 1;
      }

      .ads-content {
        width: 1200px;
        margin: 0 auto;
        height: 168px;
        position: relative;

        .left {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .wenzi1 {
            font-size: 27px;
            line-height: 38px;
            color: #000000;
            letter-spacing: 4px;
            padding-top: 20px;
          }

          .wenzi2 {
            padding: 4px 0 16px;
            font-size: 14px;
            line-height: 20px;
            color: #000000;
            letter-spacing: 5px;
            position: relative;

            &::before {
              content: "";
              width: 23px;
              border-bottom: 1px solid #BABABA;
              position: absolute;
              left: -31px;
              top: 14px;
            }

            &::after {
              content: "";
              width: 23px;
              border-bottom: 1px solid #BABABA;
              position: absolute;
              right: -31px;
              top: 14px;
            }
          }

          .btn {
            width: 188px;
            height: 38px;
            background: #F9A826;
            border-radius: 24px;
            line-height: 38px;
            text-align: center;
            font-size: 20px;
            color: #FFFFFF;
            cursor: pointer;
          }
        }

        .tel {
          padding-left: 65px;
          padding-top: 108px;
          display: flex;

          .line {
            display: flex;
            align-items: center;

            img {
              margin-right: 16px;
            }

            span {
              font-size: 18px;
              line-height: 24px;
              color: #7E7E7E;
            }

            &:nth-of-type(1) {
              margin-right: 42px;
            }
          }
        }

        .pic {
          img {
            width: 372px;
            height: 208px;
            position: relative;
            top: -38px;
          }
        }

        .ads-close2 {
          margin: 24px 0 0 14px;
          width: 75px;
          height: 28px;
          border: 1px solid #707070;
          border-radius: 14px;
          font-size: 16px;
          line-height: 28px;
          text-align: center;
          color: #7E7E7E;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          i {
            font-size: 20px;
            font-weight: bold;
            margin-right: 2px;
          }
        }
      }
    }

    .close-animate {
      .footer-ads {
        // transform: translateX(-1920px);
        // -webkit-transform: translateX(-1920px); /*兼容-webkit-引擎浏览器*/
        // -moz-transform: translateX(-1920px); /*兼容-moz-引擎浏览器*/
        transition: all 0.5s linear;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue